import { render, staticRenderFns } from "./guidanceForm.vue?vue&type=template&id=3439a7e6"
import script from "./guidanceForm.vue?vue&type=script&lang=js"
export * from "./guidanceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports